<template>
	<div class="filters-list">
		<div class="filters-container scrollable">
			<ul class="all-filters">
				<li class="option" v-for="filter in filtersOptions" :key="filter.name"
					:class="filter.class"
				>
					<!-- //* FILTER NAME -->
					<div class="option-header">
						<span class="option-name">{{ filter.name }}</span>
						<input v-if="filter.search"
							class="option-search-bar"
							v-model="filter.searchText"
							type="text" pattern="(\w+\s?)?"
							maxlength="255" placeholder="Filter options"
						/>
						<!-- //TODO make a toggle component for this part -->
						<div v-if="filter.subtypes" class="option-subtype-selector">
							<span class="material-icons hl-hover"
								:class="{ selected: filter.subtype === 'grid' }"
								@click="filter.subtype = 'grid'"
							>grid_view</span>
							<span class="material-icons hl-hover"
								:class="{ selected: filter.subtype === 'list' }"
								@click="filter.subtype = 'list'"
							>list_view</span>
						</div>
					</div>
					<!-- //* FILTER INPUT -->
					<div class="option-input">
						<!-- COMBINATION COMPOSER -->
						<combination-composer v-if="filter.type == 'combination-composer'"
							:max-combination="filter.max"
							:options="filter.values"
							v-model="currentFilters[filter.name]"
						/>
						<!-- MULTI SELECT -->
						<multi-select v-else-if="filter.type == 'multi-select'"
							:icon-size="filter.iconSize"
							:type="filter.subtype"
							:hide-label="filter.hideLabel"
							:options="filter.values"
							v-model="currentFilters[filter.name]"
						/>
						<!-- SELECT -->
						<select v-else-if="filter.type == 'select'"
							v-model="currentFilters[filter.name]"
						>
							<option v-for="(value, i) in filter.values" :key="filter.name+'-'+i"
							:value="value.key">{{ value.name }}</option>
						</select>
						<!-- TEXT INPUT -->
						<input v-else-if="filter.type == 'text'"
							v-model="currentFilters[filter.name]"
							type="text" pattern="(\w+\s?)?"
							maxlength="255" placeholder="Enter text here"
						/>
					</div>
				</li>
			</ul>
		</div>
		<div class="divider" />
		<div class="fl-footer">
			<div class="auto-apply">
				<input type="checkbox" name="auto-apply" v-model="autoApply">
				<label for="auto-apply">Auto Apply on Change</label>
			</div>
			<div class="action-buttons">
				<div class="btn danger" @click="clearFilters"	:disabled="defaultFiltersSet">clear filters</div>
				<div class="btn primary"        @click="reset"				:disabled="!modOccurred">reset</div>
				<div class="btn primary"        @click="apply"				:disabled="!modOccurred"  :class="autoApply && 'is-hidden'">apply</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	cloneDeep as _cloneDeep
} from 'lodash';
import {
	watch
} from 'vue';

import MultiSelect					from '@/components/inputs/MultiSelect.vue';
import CombinationComposer	from '@/components/inputs/CombinationComposer.vue';

import { FILTERS_DEFAULT, FILTERS_DEF }	from '@/utils/Filters';

export default {
	name: 'filters-list',
	props: {
		filters: { // v-model
			type: Object,
			required: true
		}
	},
	components: {
		MultiSelect,
		CombinationComposer
	},
	data() {
		return {
			autoApply: true,
			filtersOptions: _cloneDeep(FILTERS_DEF),
			currentFilters: _cloneDeep(this.filters)
		};
	},
	computed: {
		modOccurred() {
			return this.checkDiff(this.filters, this.currentFilters);
		},
		defaultFiltersSet() {
			return !this.checkDiff(this.filters, FILTERS_DEFAULT);
		}
	},
	watch: {
		modOccurred(value) {
			if (value === true && this.autoApply)
				this.apply();
		}
	},
	beforeMount() {
		for (const filter of this.filtersOptions) {
			const classList = { };
			if (filter.labelPosition)
				classList[`label-position-${filter.labelPosition}`] = true;

			if (filter.search) {
				classList.searchable = !!filter.search;
				filter.values = filter.search('');
				watch(() => filter.searchText, (value) => {
					filter.values = filter.search(value);
				});
			}
			if (filter.subtypes)
				filter.subtype = 'grid';
			filter.class = classList;
		}
	},
	methods: {
		checkDiff(filters1, filters2) {
			for (const key in filters1) {
				const f1 = filters1[key];
				const f2 = filters2[key];
				if (Array.isArray(f1)) {
					if (f1.length !== f2.length)
						return true;
					for (const value of f1) {
						if (!f2.includes(value))
							return true;
					}
				} else if (f1 !== f2)
					return true;
			}
			return false;
		},
		clearFilters() {
			this.currentFilters = _cloneDeep(FILTERS_DEFAULT);
			this.apply();
		},
		reset() {
			this.currentFilters = _cloneDeep(this.filters);
		},
		apply() {
			this.$nextTick(() => {
				if (this.modOccurred) {
					this.$emit('update:filters', _cloneDeep(this.currentFilters));
					if (!this.autoApply)
						this.$emit('filters-applied');
				}
			});
		}
	}
};
</script>

<style lang="scss">
@import '@/assets/colors.scss';

.filters-list {
	display: flex;
	flex-direction: column;
	height: 100%;
	.filters-container {
		flex: auto;
		display: flex;
		flex-direction: column;
    overflow-y: scroll;
		overflow-x: hidden;
		background: $primary;
		.all-filters {
			height: 100%;
			margin: 0;
			padding: 20px 0;
			.option {
				display: flex;
				color: #eee;
				&.searchable,
				&.label-position-top {
					flex-direction: column;
					.option-header {
						width: 100%;
						margin-bottom: 5px;
					}
				}
				&:not(:last-child) {
					margin-bottom: 1rem;
				}
				.option-header {
					display: flex;
					align-items: center;
					.option-name {
						display: flex;
						align-items: center;
						min-width: 85px;
						text-align: left;
						padding-left: 10px;
						text-transform: uppercase;
						font-style: italic;
						font-weight: 700;
					}
					.option-search-bar {
						flex: auto;
						height: 24px;
						margin: 0 5px;
					}
					.option-subtype-selector {
						width: 34px;
						>span {
							width: 28px;
							padding: 2px;
							border-radius: 5px;
							cursor: pointer;
							&.selected {
								background: var(--light-blue);
								cursor: default;
							}
						}
					}
				}
				.option-input {
					flex: auto;
					justify-content: flex-start;
					align-items: center;
					display: flex;
					padding: 0 5px;
					>select, input[type="text"] {
						width: 100%;
					}
					>:not(:first-child) {
						margin-left: 10px;
					}
				}
			}
		}
	}
	.fl-footer {
		background: var(--gray-blue);
		.auto-apply {
			color: white;
			margin: 5px 0;
			display: flex;
			align-items: center;
			justify-content: center;
			input {
				margin: 0 5px;
			}
		}
		.action-buttons {
			display: flex;
			justify-content: space-around;
			align-items: center;
			height: 55px;
			min-height: 55px;
			>.btn {
				height: 35px;
				&.is-hidden {
					display: none;
				}
			}
		}
	}
}
.divider {
	width: 100%;
	height: 5px;
	min-height: 5px;
	border-top: 1px solid #eee;
	border-bottom: 1px solid #eee;
}
</style>
